import { appFetch, AppFetchResponse } from "../../utils/appFetch";

export const listV2ApiKeys = async (selectedDomain: string) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/api-keys`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        domain: selectedDomain,
    });
    return res;
};

export const createV2ApiKey = async (
    selectedDomain: string,
    type: "public" | "secret",
    allowedOrigins: string[] = []
) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/api-keys`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain: selectedDomain,
        params: {
            type,
            allowed_origins: allowedOrigins,
        },
    });
    return res;
};

export const revokeV2ApiKey = async (selectedDomain: string, id: number) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/api-keys/${id}/revoke`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain: selectedDomain,
    });
    return res;
};
